export enum UserMutationsEnum {
    STORE_USER_PROFILE = 'storeUserProfile',
    STORE_USER_ROLES = 'storeUserRoles',
    STORE_API_TOKEN = 'storeApiToken',
    STORE_USER_ME_TOKEN = 'storeUserMeToken',
    STORE_ADMIN_STATUS = 'storeAdminStatus',
    STORE_USER_STATUS = 'storeUserStatus',
    STORE_USER_TOKEN_DATA = 'storeUserTokenData',
}
